module.exports = __webpack_public_path__ + "static/media/module-program-card-banner-wakeup-workout@2x.fc330d1d.png";